export default __webpack_public_path__ + "static/thumb-landscape-bdf5993dfdf64df530ddca38fcaeefda.jpg";